import { Box, Heading, Text, Button, Link } from "@chakra-ui/react";
import { Link as ReactDomLink } from "react-router-dom";
import * as PATHS from "../utils/paths";
import Navbar from "../components/Navbar/Navbar";

export default function NotFound(props) {
  return (
      <>
      <Navbar handleLogout={props.handleLogout} user={props.user} />
      
    <Box textAlign="center" py={10} px={6}>
      <Heading
        display="inline-block"
        as="h2"
        size="2xl"
        bgGradient="linear(to-r, teal.400, teal.600)"
        backgroundClip="text"
      >
        404
      </Heading>
      <Text fontSize="18px" mt={3} mb={2}>
        Page Not Found
      </Text>
      <Text color={"gray.500"} mb={6}>
        The page you're looking for does not seem to exist
      </Text>

      <Link to={PATHS.HOMEPAGE} as={ReactDomLink} style={{textDecoration:"none"}}>
        <Button
          colorScheme="teal"
          bgGradient="linear(to-r, teal.400, teal.500, teal.600)"
          color="white"
          variant="solid"
        >
          Go to Home
        </Button>
      </Link>
    </Box>
    </>
  );
}
